import { Components } from "@mui/material/styles";

export const MuiCircularProgress: Components["MuiCircularProgress"] = {
    defaultProps: {
        thickness: 4,
        size: 40,
    },
};
